import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import AOS from 'aos'
import 'aos/dist/aos.css'
import i18n from './i18n'
import store from './state/store'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue-3/dist/bootstrap-vue-3.css'
import BootstrapVue3 from 'bootstrap-vue-3'
import vClickOutside from 'click-outside-vue3'
import VueApexCharts from 'vue3-apexcharts'
import Maska from 'maska'

import VueFeather from 'vue-feather'
import Particles from 'particles.vue3'

import VueScrollTo from 'vue-scrollto'

import '@/assets/scss/config/minimal/app.scss'
import '@vueform/slider/themes/default.css'
import { Buffer } from 'buffer'

window.Buffer = Buffer

AOS.init({
  easing: 'ease-out-back',
  duration: 1000
})

createApp(App)
  .use(store)
  .use(router)
  .use(VueApexCharts)
  .use(BootstrapVue3)
  .use(VueScrollTo)
  .component(VueFeather.type, VueFeather)
  .use(Maska)
  .use(Particles)
  .use(i18n)
  .use(vClickOutside)
  .mount('#app')
